import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import skylarqLogo from '../../../assets/skylarq_logo_small.png';

interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  isCollapsed,
  onToggleCollapsed,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`flex items-center gap-3 flex-shrink-0 border-b border-neutral-100 ${
        isCollapsed ? 'p-4 px-3' : 'p-4'
      }`}
    >
      {isCollapsed ? (
        <div className="relative group flex justify-center w-full">
          <button
            onClick={() => navigate('/datasets')}
            className="flex items-center justify-center transition-opacity group-hover:opacity-0"
          >
            <img src={skylarqLogo} alt="Skylarq" className="w-8 h-8 object-contain rounded-sm" />
          </button>
          <button
            onClick={onToggleCollapsed}
            className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-150"
            title="Expand menu (⌘B)"
          >
            <div className="p-2 rounded-lg bg-white border border-neutral-200 text-neutral-600">
              <ChevronRight className="w-4.5 h-4.5" />
            </div>
          </button>
        </div>
      ) : (
        <>
          <button
            onClick={() => navigate('/datasets')}
            className="flex items-center gap-2 transition-opacity hover:opacity-70"
          >
            <img src={skylarqLogo} alt="Skylarq" className="w-8 h-8 object-contain rounded-sm" />
            <span className="text-[15px] font-semibold tracking-tight text-neutral-800">
              Skylarq
            </span>
          </button>
          <button
            onClick={onToggleCollapsed}
            className="ml-auto p-1.5 rounded-md text-neutral-500 hover:bg-neutral-200 hover:text-neutral-600 transition"
            title="Collapse sidebar (⌘B)"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
        </>
      )}
    </div>
  );
};
